module.exports = __webpack_public_path__ + "img/1.e6d61ebc.png";